(function(root, factory) {
    'use strict';
    if (typeof exports === 'object') {
        // CommonJS
        module.exports = factory(require('@ali/network'), require('@ali/share-data'), require('@ali/simple-ua'));
    } else {
        // Global Variables
        root.UEM = root.UEM || {};
        root.UEM.log = factory(root.UEM.network, root.UEM.shareData, root.UEM.ua);
    }
}(this, function(network, shareData, ua) {
    'use strict';

    // 兼容同构
    if (typeof window === 'undefined') return {};

    // 设置默认参数
    var _baseRequestParams = {};

    var out = {
        set prefix(value) {
            // 防止末尾没带斜杠
            if (value.slice(-1) !== '/') { value += '/'; }
            window.__UEM_LOG_PREFIX__ = value;
        },
        get prefix() {
            return window.__UEM_LOG_PREFIX__ || '';
        }
    };

    function _valToLowerCase(val) {
        return ((typeof val === 'string') ? val.toLowerCase() : val);
    }

    /**
     * 检查对象参数非空
     * @param  {any}    objVal  参数值
     * @param  {string} objName 参数名
     */
    function _checkObjectNotEmpty(objVal, objName) {
        if (!objVal) {
            throw new Error('argument `' + objName + '` is required');
        }
    }

    /**
     * 检查字符串参数非空
     * @param  {any}    strVal  参数值
     * @param  {string} strName 参数名
     */
    function _checkStringNotEmpty(strVal, strName) {
        _checkObjectNotEmpty(strVal, strName);
        if (typeof strVal !== 'string') {
            throw new Error('argument `' + strName + '` should be string');
        }
    }

    /**
     * 浅复制
     * @params {object...} args - 多个被复制的对象
     */
    function _simpleExtend() {
        var src = {},
            ext,
            prop,
            i = 0;
        for (; i < arguments.length; i++) {
            ext = arguments[ i ];
            for (prop in ext) {
                if (ext.hasOwnProperty(prop)) {
                    src[ prop ] = ext[ prop ];
                }
            }
        }
        return src;
    }

    /**
     * 向 obj 中添加 自定义参数对象
     * @param  {Object} defaultArg  日志必要参数对象
     * @param  {Object} customData  日志自定义参数对象
     */
    function _addCustomData(obj, customData) {
        if (obj) {
            obj.data = _valToLowerCase(JSON.stringify(_simpleExtend(_baseRequestParams, customData)));
        }
        return obj;
    }

    /**
     * 在 arguments 获取 defaultArgArr 中定义的变量
     * @param  {arguments}    args          log function 的 arguments
     * @param  {Arry<string>} defaultArgArr 默认参数列表
     * @param  {Boolean}      holdUrl       是否保留url的大写
     * FIXFOR Issue #1:  修复logRedirect的时候组件错将url的value转成小写导致展开的公参实效，因此增加 holdUrl && defaultArgArr[i] === 'url'来判断 by cjx089807
     */
    function _getDefaultArgs(args, defaultArgArr, holdUrl) {
        var i = 0,
            defaultArg = {};
        if (defaultArgArr instanceof Array) {
            for (; i < defaultArgArr.length; i++) {
                // FIXFOR Issue #1:   增加 holdUrl && defaultArgArr[i] === 'url'来判断 by cjx089807
                var arg = holdUrl && defaultArgArr[ i ] === 'url' ? args[ i ] : _valToLowerCase(args[ i ]);
                _checkStringNotEmpty(arg, defaultArgArr[ i ]);
                defaultArg[ defaultArgArr[ i ] ] = arg;
            }
        }
        _addCustomData(defaultArg, args[ i ]);
        if (!isSetup && !doSetupWarn) {
            console.warn('log setup requred first!');
            doSetupWarn = true;
        }
        return defaultArg;
    }

    /**
     * 日志工厂
     * 发布一个和 logType 同名的日志方法，调用的接口地址和 logType 相同，defaultArgArr 中的参数必填
     * 发布一个名为日志类型 logType + 'Redirect' 的方法，第一个参数为重定向的地址
     * @param  {string}       logType       日志类型
     * @param  {Arry<string>} defaultArgArr 默认参数列表
     */
    function _generateExportsLogFunction(logType, defaultArgArr) {
        var logFun;
        if (!defaultArgArr) {
            // 如果没有默认参数，则自定义参数不能为空（防止误用）
            logFun = function(params) {
                _checkObjectNotEmpty(params);
                // url 即为 日志类型
                network.ping(out.prefix + logType, _addCustomData({}, params));
            };
        } else {
            // 如果有默认参数，则需要检查每个默认参数都不能为空字符串
            logFun = function() {
                network.ping(out.prefix + logType, _getDefaultArgs(arguments, defaultArgArr));
            };
        }
        // 输出的方法名和日志类型 logType 相同，即和 url 相同
        out[ logType ] = logFun;
        // 输出的方法名为日志类型 logType + 'Redirect' 的方法
        var defaultRedirectArgArr = [ 'url' ].concat(defaultArgArr),
            logTypeRedirect = logType + 'Redirect';
        out[ logTypeRedirect ] = function() {
            network.redirect(network.parseQuery(
                // FIXFOR Issue #1:   logRedirect时保留url值的大小写
                _getDefaultArgs(arguments, defaultRedirectArgArr, true),
                out.prefix + logTypeRedirect
            ));
        };
    }

    /**
     * 打印日志
     * @param  {Object} params 日志自定义参数对象
     *
     * exports.log = function (params) { }
     * exports.logRedirect = function (url, params) { }
     */
    _generateExportsLogFunction('log');

    /**
     * 打印 页面访问 日志
     * @param  {string} page   访问页面
     * @param  {Object} params 日志自定义参数对象
     *
     * exports.logVisit = function (page, params) { }
     * exports.logVisitRedirect = function (url, page, params) { }
     */
    _generateExportsLogFunction('logVisit', [ 'page' ]);

    /**
     * 打印 点击 日志
     * @param  {string} clickId 点击目标
     * @param  {Object} params  日志自定义参数对象
     *
     * exports.logClick = function (clickId, params) { }
     * exports.logClickRedirect = function (url, clickId, params) { }
     */
    _generateExportsLogFunction('logClick', [ 'clickId' ]);


    /**
     * 打印 事件 日志
     * @param  {string} category 事件分类
     * @param  {string} action   事件动作
     * @param  {Object} params   日志自定义参数对象
     *
     * exports.logEvent = function (category, action, params) { }
     * exports.logEventRedirect = function (url, category, action, params) { }
     */
    _generateExportsLogFunction('logEvent', [ 'category', 'action' ]);


    /**
     * 打印 系统 日志
     * @param  {Object} params 日志自定义参数对象
     *
     * exports.logSystem = function (params) { }
     * exports.logSystemRedirect = function (url, params) { }
     */
    _generateExportsLogFunction('logSystem');


    /**
     * 设置 baseParam
     * @param {string} name - 设置参数名
     * @param {string} val - 设置 name 的值为 val
     */
    out.baseParam = function(name, val) {
        _checkConfiguration(name, val);
        _baseRequestParams[ name ] = val || _baseRequestParams[ name ];
        return _baseRequestParams[ name ];
    };

    /**
     * [logAjaxError 打印ajax请求错误信息]
     * @param  {[type]} eventAction  操作标识
     * @param  {[type]} xhr        异常对象
     * @param  {[type]} customData 自定字段
     */
    out.logAjaxError = function(eventAction, xhr, customData) {
        customData = customData || {};
        customData.xtime = xhr && xhr.xtime ? xhr.xtime : 0; //请求耗时
        customData.statechange = xhr && xhr.statechange ? xhr.statechange : ''; //readyState及status状态变化
        customData.errortime = xhr && xhr.errortime ? xhr.errortime : ''; //发生错误时的请求时间戳
        customData.parseError = xhr && xhr.parseError ? xhr.parseError : false; //是否结果值转换json对象时错误
        customData.readyState = xhr ? xhr.readyState : ''; //ajax的readyState状态
        customData.status = xhr ? xhr.status : ''; //ajax的status状态
        customData.customRequestUrl = xhr && xhr.customRequestUrl ? xhr.customRequestUrl : ''; //请求的url
        var responseText = '';
        if (xhr && xhr.responseText) {
            responseText = xhr.responseText.replace(/(\n)+|(\r\n)+/g, '');
            responseText = responseText.replace(/(`)+/g, '');
        }
        customData.responseText = responseText; //结果值
        out.logEvent('sample-error', eventAction, customData);
    };

    /**
     * 设置当前业务路径
     * @param {String} pathName 自定义路径名称
     */
    out.path = function(pathName) {
        out.baseParam('fact_link_id', pathName);
    };

    var LoadingChance = 1;
    /**
     * 【loading页总UV】
     * @param {Object} params 日志自定义参数对象
     */
    out.loading = function(params) {
        // loading日志只允许打一次
        if (LoadingChance && LoadingChance--) {
            this.logVisit('act_load', params);
        }
    };

    var readyChance = 1;
    /**
     * 【ready页总UV】
     * @param {Object} params 日志自定义参数对象
     */
    out.ready = function(params) {
        // ready日志只允许打一次
        if (readyChance && readyChance--) {
            this.logVisit('act_ready', params);
        }
    };

    var startChance = 1;
    /**
     * 【用户一次访问只会打一次的参与总UV】
     * @param {Object} params 日志自定义参数对象
     */
    out.start = function(params) {
        // start日志只允许打一次
        if (startChance && startChance--) {
            this.logClick('act_start', params);
        }
    };

    /**
     * 【参与总UV】
     * @param {Object} params 日志自定义参数对象
     */
    out.mutiStart = function(params) {
        // start日志只允许打一次
        this.logClick('act_start', params);
    };

    /**
     * 【场景总UV】废弃
     * @param {string,number} sceneId 场景ID
     * @param {Object} params 日志自定义参数对象
     */
    out.scene = function(sceneId, params) {
        if (!sceneId) {
            throw new Error('sceneId required.');
        }
        this.logVisit('act_scene' + sceneId, params);
    };

    /**
     * 【页面访问场景总UV】
     * @param {string,number} sceneId 场景ID
     * @param {Object} params 日志自定义参数对象
     */
    out.visitScene = function(sceneId, params) {
        if (!sceneId) {
            throw new Error('sceneId required.');
        }
        params = params || {};
        params.fact_node_ext = sceneId;
        this.logVisit('pg_scene', params);
    };

    /**
     * 【行为场景总UV】
     * @param {string,number} sceneId 场景ID
     * @param {Object} params 日志自定义参数对象
     */
    out.actScene = function(sceneId, params) {
        if (!sceneId) {
            throw new Error('sceneId required.');
        }
        params = params || {};
        params.fact_node_ext = sceneId;
        this.logClick('act_scene', params);
    };

    /**
     * 【行为场景总UV】
     * @param {string,number} sceneId 场景ID
     * @param {Object} params 日志自定义参数对象
     */
    out.actRedirectScene = function(url, sceneId, params) {
        if (!sceneId) {
            throw new Error('sceneId required.');
        }
        params = params || {};
        params.fact_node_ext = sceneId;
        this.logClickRedirect(url, 'act_scene', params);
    };

    /**
     * 【分享总UV】
     * @param {Object} params 日志自定义参数对象
     */
    out.share = function(params) {
        this.logClick('act_share', params);
    };

    /**
     * 【下载总UV】
     * @param {Object} params 日志自定义参数对象
     */
    out.download = function(params) {
        this.logClick('act_download', params);
    };

    /**
     * 【抽奖按钮点击总UV】
     * @param {Object} params 日志自定义参数对象
     */
    out.draw = function(params) {
        this.logClick('act_draw', params);
    };

    /**
     * 【自动抽奖总UV】
     * @param {Object} params 日志自定义参数对象
     */
    out.autoDraw = function(params) {
        this.logEvent('act', 'act_draw_auto', params);
    };

    /**
     * 【中奖用户总UV】
     * @param {Object} params 日志自定义参数对象
     */
    out.winPrize = function(params) {
        this.logEvent('act', 'act_win_prize', params);
    };

    /**
     * 【兑奖按钮点击总UV】
     * @param {Object} params 日志自定义参数对象
     */
    out.getPrize = function(params) {
        this.logClick('act_get_prize', params);
    };

    /**
     * 【自动兑奖总UV】
     * @param {Object} params 日志自定义参数对象
     */
    out.autoGetPrize = function(params) {
        this.logEvent('act', 'act_get_prize_auto', params);
    };

    function _addShareData2baseParam() {
        try {
            var sd = shareData.decodeShareData(network.query('__sd'));
            out.baseParam('last_node_sessionid', sd.sessionid);
            out.baseParam('share_type', sd.type);
            out.baseParam('share_style', sd.style);
            out.baseParam('share_time', sd.time);
            out.baseParam('returning_time', +new Date() - sd.time); // 冗余字段方便wa直接计算
            out.baseParam('share_id', sd.sessionid + '_' + sd.time); // 冗余字段方便wa直接计算
            out.baseParam('node_deep', sd.deep);
            return;
        } catch (e) {
        }
        out.baseParam('node_deep', 0);
    }

    /**
     * 初始化actname作为基础参数
     */
    function _initActName() {
        try {
            if (typeof window !== 'undefined') {
                var actPlatRegex = /actplat\/frontend\/page\/(show|preview)\/(\w+)\//;
                var actPlatResult = location.href.match(actPlatRegex);
                var actNormalResult = location.pathname.match(/\/(\w+)/);
                var actname = '';
                if (actPlatResult) {
                    // 部署到平台上的静态h5活动
                    actname = actPlatResult[ 2 ];
                } else {
                    actname = actNormalResult ? actNormalResult[ 1 ] : ' ';
                }
                // 西兰花兼容模式
                var broccoliAppInfo = window.__BROCCOLI_APPINFO__;
                out.baseParam('actname', broccoliAppInfo ? broccoliAppInfo.appCode : actname);
                out.baseParam('app_key', broccoliAppInfo ? broccoliAppInfo.appId : ('activity_actname_' + actname));
            }
        } catch (error) {

        }
    }

    function _initPlatform() {
        out.baseParam('platform', ua.pf);
        out.baseParam('app_id', '3733');
    }

    function _checkConfiguration(name, val) {
        if (confData && !confData.intl && name === 'type' && val.indexOf('cn_') === -1) {
            throw new Error('type value Error!');
        }
    }

    _addShareData2baseParam();

    _initActName();

    _initPlatform();

    var LOG_HOST_NAME = [ 'https://activity.uc.cn/logCollect/', 'http://rc.ucweb.com/logCollect/' ];
    var LOG_TEST_HOST_NAME = '//logcollectomelette.dev.uae.uc.cn/logCollect/';
    var isSetup = false;
    var doSetupWarn = false;
    var confData;
    /*
     *  初始化log服务参数
     */
    out.setup = function(conf) {
        confData = conf;
        out.baseParam('sessionid', ua.getSessionId());
        if (conf) {
            out.prefix = (conf.prefix) || (conf.debug ? LOG_TEST_HOST_NAME : LOG_HOST_NAME[ conf && conf.intl ? 1 : 0 ]);
        }
        if (conf && conf.type) {
            out.baseParam('type', conf.type);
        } else {
            throw new Error('type required!');
        }
        if (conf && conf.app_key) {
            out.baseParam('app_key', conf.app_key);
        }
        if (conf && conf.actname) {
            out.baseParam('actname', conf.actname);
        }
        isSetup = true;
    };

    return out;
}));
